export default __webpack_public_path__ + "static/media/paste.c02c65a5.svg";